// extracted by mini-css-extract-plugin
export default {"text_container":"TextDisplay_text_container__8U-5h","text_viewer":"TextDisplay_text_viewer__0kmT3","copy_button":"TextDisplay_copy_button__9KZVN"};